import {TreatmentDefinitionSummaryModel} from '../treatmentDefinitionSummaryModel';
import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {
    FormDefinitionFormSummaryConverter
} from '../../../../../../form/definition/form/api/entity/converter/formDefinitionFormSummary.converter';
import {Injectable} from '@angular/core';
import {LovValueSummaryConverter} from "../../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter";
import {PermissionsConverter} from "../../../../../../common/converter/permissions.converter";

@Injectable({
    providedIn: 'root'
})
export class TreatmentDefinitionSummaryConverter extends HttpModelConverter<TreatmentDefinitionSummaryModel> {

    constructor(private formDefinitionFormConverter: FormDefinitionFormSummaryConverter,
                private lovValueConverter: LovValueSummaryConverter,
                private permissionConverter: PermissionsConverter) {
        super();
    }

    protected createInstance(): TreatmentDefinitionSummaryModel {
        return new TreatmentDefinitionSummaryModel();
    }

    protected enrichObject(result: TreatmentDefinitionSummaryModel, src: TreatmentDefinitionSummaryModel) {
        result.formDefinition = this.formDefinitionFormConverter.convert(src.formDefinition);
        result.performedBy = this.lovValueConverter.convert(result.performedBy);
        result.type = this.lovValueConverter.convert(result.type);
        result.permissions = this.permissionConverter.convert(result.permissions);
    }

}
